<table class="table table-striped" *ngIf="settingsLoaded">
  <tbody>
  <tr>
    <td>Enabled Entities</td>
    <td>
      <span *ngFor="let entity of ['Candidate', 'ClientContact', 'ClientCorporation']" class="entity">
        <mat-checkbox [disabled]="!canEdit" [(ngModel)]="scheduledMergesService.scheduledDedupeSettings.enabledEntities[entity]" (change)="changed()">
          {{ entity }}
        </mat-checkbox>
      </span>
    </td>
  </tr>
  <tr>
    <td>Days scheduled</td>
    <td>
      <span *ngFor="let day of scheduledMergesService.days" class="day">
        <mat-checkbox [disabled]="!canEdit" [(ngModel)]="scheduledMergesService.scheduledDedupeSettings.enabledDays[day.toString()]" (change)="changed()">
          {{ utilsService.getDayStringForDayNumber(day) }}
        </mat-checkbox>
      </span>
    </td>
  </tr>
  <tr>
    <td>Perform merges at</td>
    <td>
      <mat-select [disabled]="!canEdit" [(ngModel)]="scheduledMergesService.scheduledDedupeSettings.mergeTimeUTC">
        <mat-option *ngFor="let scheduleTime of scheduleTimes" [value]="scheduleTime.timeValue"
                    (onSelectionChange)="optionChanged($event)">
          {{ get24hrDisplay(scheduleTime.timeValue) }}
        </mat-option>
      </mat-select>
    </td>
  </tr>
  <tr>
    <td>Batch size per selected entity</td>
    <td>
      <mat-select [disabled]="!canEdit" [(ngModel)]="scheduledMergesService.scheduledDedupeSettings.batchSize">
        <mat-option *ngFor="let batchSize of batchSizes" [value]="batchSize" (onSelectionChange)="optionChanged($event)">
          {{ batchSize }}
        </mat-option>
      </mat-select>
    </td>
  </tr>
  </tbody>
</table>
